// Module
var code = `<!--
<ul>
  <li>
    <header>
      <p class="attributes">
        {{content.0}}
          <span>{{event}}</span>
          <span>{{action}}</span>

        {{/content.0}}
      </p>
    </header>
  </li>
</ul>
-->


<table>
    <thead>
    <tr>
        <th>Common UI Events</th>
        <th>Common UI Actions</th>
    </tr>
    </thead>
    <tbody>
    {{#content.0.arr}}
    <tr>
        <td>{{event}}</td>
        <td>{{action}}</td>
    </tr>
    {{/content.0.arr}}
    </tbody>
</table>


<table>
    <thead>
    <tr>
        <th>Other UI Events</th>
        <th>Other UI Actions</th>
    </tr>
    </thead>
    <tbody>
    {{#content.1.arr}}
    <tr>
        <td>{{event}}</td>
        <td>{{action}}</td>
    </tr>
    {{/content.1.arr}}
    </tbody>
</table>
`;
// Exports
module.exports = code;